
import React from 'react';
import { useDispatch } from 'react-redux';

import useAuthToken from './useAuthToken';
import checkSessionGetActions from '../../sagas/mysliveckyportal/checkSession';

export default function useCheckSession() {

    const dispatch = useDispatch();
    const checkSessionActions = checkSessionGetActions(dispatch);
    const token = useAuthToken();

    React.useEffect(() => {
        if (token) {
            checkSessionActions.checkSessionStart(token);
        } else {
            checkSessionActions.checkSessionStop();
        }
    });
}
